import { Badge, Box, Button, Divider, Hidden, Text } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { type CTAData, useCTAsData } from 'services/hooks/use-ctas-data';
import { BenefitList } from '../benefit-list/benefit-list';
import { PricingPlanHeader } from './pricing-plan-header/pricing-plan-header';
import css from './showcase.module.css';
function CTAButton({
  data
}: {
  data: CTAData;
}) {
  return <Box className={css.buttonContainer} data-sentry-element="Box" data-sentry-component="CTAButton" data-sentry-source-file="showcase.tsx">
            <Button variant={data.variant} size="base" href={data.href} {...data.dataAttributes} data-sentry-element="Button" data-sentry-source-file="showcase.tsx">
                {data.text}
            </Button>
        </Box>;
}
export function Showcase() {
  const {
    t
  } = useTranslation('pricing_v2_3');
  const proCtaData = useCTAsData('pricing-page-showcase-pro');
  const businessCtaData = useCTAsData('pricing-page-showcase-business');
  return <Box className={css.showCaseContainer} data-sentry-element="Box" data-sentry-component="Showcase" data-sentry-source-file="showcase.tsx">
            <Box className={css.personalPlansContainer} data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                <Box className={css.column} data-testid="beginner-column" data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                    <PricingPlanHeader planName="beginner" size="base" data-sentry-element="PricingPlanHeader" data-sentry-source-file="showcase.tsx" />
                    <Box className={css.benefitsContainer} data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                        <Box data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                            <Text size="minor-base" weight="medium" className="mbe-12" data-sentry-element="Text" data-sentry-source-file="showcase.tsx">
                                {t(`groups.beginner.with`)}
                            </Text>
                            <BenefitList plan="beginner" data-sentry-element="BenefitList" data-sentry-source-file="showcase.tsx" />
                        </Box>
                    </Box>
                </Box>
                <Hidden above="md" data-sentry-element="Hidden" data-sentry-source-file="showcase.tsx">
                    <Divider data-sentry-element="Divider" data-sentry-source-file="showcase.tsx" />
                </Hidden>
                <Box className={css.column} data-testid="pro-column" data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                    <PricingPlanHeader planName="pro" size="base" data-sentry-element="PricingPlanHeader" data-sentry-source-file="showcase.tsx" />
                    <Box className={css.benefitsContainer} data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                        <Box data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                            <Text size="minor-base" weight="medium" className="mbe-12" data-sentry-element="Text" data-sentry-source-file="showcase.tsx">
                                {t(`groups.pro.with`)}
                            </Text>
                            <BenefitList plan="pro" data-sentry-element="BenefitList" data-sentry-source-file="showcase.tsx" />
                        </Box>
                        {proCtaData ? <CTAButton data={{
            ...proCtaData,
            dataAttributes: proCtaData.dataAttributes
          }} /> : null}
                    </Box>
                </Box>
                <Hidden above="md" data-sentry-element="Hidden" data-sentry-source-file="showcase.tsx">
                    <Divider data-sentry-element="Divider" data-sentry-source-file="showcase.tsx" />
                </Hidden>
                <Box className={css.column} data-testid="teams-column" data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                    <Badge className={css.badge} variant="new" data-sentry-element="Badge" data-sentry-source-file="showcase.tsx">
                        {t('designedForTeams')}
                    </Badge>
                    <PricingPlanHeader planName="teams" size="base" data-sentry-element="PricingPlanHeader" data-sentry-source-file="showcase.tsx" />
                    <Box className={css.benefitsContainer} data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                        <Box data-sentry-element="Box" data-sentry-source-file="showcase.tsx">
                            <Text size="minor-base" weight="medium" className="mbe-12" data-sentry-element="Text" data-sentry-source-file="showcase.tsx">
                                {t(`groups.teams.with`)}
                            </Text>
                            <BenefitList plan="teams" data-sentry-element="BenefitList" data-sentry-source-file="showcase.tsx" />
                        </Box>
                        {businessCtaData ? <CTAButton data={{
            ...businessCtaData,
            dataAttributes: businessCtaData.dataAttributes
          }} /> : null}
                    </Box>
                </Box>
            </Box>
        </Box>;
}